import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { GalaxyApi } from "@/api";
import { rethrowSimple } from "@/utils/simple-error";
import EditSecretsForm from "@/components/ConfigTemplates/EditSecretsForm.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'EditSecrets',
    props: {
        objectStore: null,
        template: null
    },
    setup(__props) {
        const props = __props;
        const title = computed(() => `Update Storage Location ${props.objectStore?.name} Secrets`);
        async function onUpdate(secretName, secretValue) {
            const { error } = await GalaxyApi().PUT("/api/object_store_instances/{uuid}", {
                params: { path: { uuid: props.objectStore.uuid } },
                body: {
                    secret_name: secretName,
                    secret_value: secretValue,
                },
            });
            if (error) {
                rethrowSimple(error);
            }
        }
        return { __sfc: true, props, title, onUpdate, EditSecretsForm };
    }
});
